import type {ParamValue} from './ParamValue';
import type {RelatedParamDefinitions} from './RelatedParamDefinitions';

export type ParamDefinition = {
  paramDefinitionId: string;
  paramDefinitionKey: string | null;
  type: string;
  unit: string | null;
  values: Array<ParamValue>;
  label: string | null;
  relatedParamDefinitionIds: Array<RelatedParamDefinitions> | null;
  isMandatory: boolean;
  imageCategoryId: string | null;
};
